import _implicitStylesheets from "./guidedInstallModal.css";
import _implicitScopedStylesheets from "./guidedInstallModal.scoped.css?scoped=true";
import _axIcon from "ax/icon";
import _wdsLink from "wds/link";
import _wdsAnalyticsInstrument from "wds/analyticsInstrument";
import _wdsButton from "wds/button";
import _i18nLink from "i18n/link";
import _wdsModal from "wds/modal";
import {freezeTemplate, parseFragment, registerTemplate} from "lwc";
const $fragment1 = parseFragment`<p class="zip-status initial-focus${0}" role="status" tabindex="-1" type-style="display-8"${2}>${"t1"}</p>`;
const $fragment2 = parseFragment`<li${3}>${"t1"}</li>`;
const $fragment3 = parseFragment`<a${"a0:href"}${3}>${"t1"}</a>`;
const $fragment4 = parseFragment`<span type-style="display-8"${3}>${"t1"}</span>`;
const $fragment5 = parseFragment`<span type-style="display-8"${3}>${"t1"}</span>`;
const $fragment6 = parseFragment`<p type-style="body-2" class="desktop-body${0}"${2}>${"t1"}</p>`;
const $fragment7 = parseFragment`<p type-style="caption" class="desktop-fallback${0}"${2}>${"t1"}</p>`;
const $fragment8 = parseFragment`<p type-style="body-2" class="subtitle${0}"${2}>${"t1"}</p>`;
const $fragment9 = parseFragment`<div class="prompt-container initial-focus${0}" role="region"${"a0:aria-label"} tabindex="0"${2}><pre class="prompt${0}"${2}><code${"a2:id"} type-style="code"${"c2"}${2}>${"t3"}</code></pre></div>`;
const $fragment10 = parseFragment`<p type-style="body-2" class="subtitle${0}"${2}>${"t1"}</p>`;
const $fragment11 = parseFragment`<div class="prompt-container initial-focus${0}" role="region"${"a0:aria-label"} tabindex="0"${2}><pre class="prompt${0}"${2}><code type-style="code"${3}>${"t3"}</code></pre></div>`;
const stc0 = {
  classMap: {
    "guided-install-top-layer": true
  },
  attrs: {
    "popover": "manual"
  },
  key: 1
};
const stc1 = {
  classMap: {
    "zip-steps": true
  },
  attrs: {
    "type-style": "body-2"
  },
  key: 7
};
const stc2 = {
  classMap: {
    "zip-help-link": true
  },
  attrs: {
    "type-style": "caption"
  },
  key: 10
};
const stc3 = {
  props: {
    "size": "xsmall",
    "icon": "new_window",
    "ariaHidden": "true"
  },
  key: 13
};
const stc4 = {
  classMap: {
    "zip-desktop-hint": true
  },
  attrs: {
    "type-style": "caption"
  },
  key: 14
};
const stc5 = {
  "zip-desktop-link": true
};
const stc6 = {
  "type": "link"
};
const stc7 = {
  classMap: {
    "desktop-status": true,
    "initial-focus": true
  },
  attrs: {
    "role": "status",
    "tabindex": "-1"
  },
  key: 18
};
const stc8 = {
  props: {
    "icon": "spinner",
    "size": "xsmall",
    "ariaHidden": "true"
  },
  key: 22
};
const stc9 = {
  classMap: {
    "show-full-row": true
  },
  key: 33
};
const stc10 = {
  "show-full-toggle": true
};
const stc11 = {
  classMap: {
    "npx-note": true
  },
  attrs: {
    "type-style": "body-3"
  },
  key: 36
};
const stc12 = {
  slotAssignment: "footer",
  classMap: {
    "footer": true
  },
  key: 42
};
const stc13 = {
  "footer-done-button": true
};
const stc14 = {
  "footer-try-again-button": true
};
const stc15 = {
  "footer-download-button": true
};
const stc16 = {
  "footer-copy-button": true
};
function tmpl($api, $cmp, $slotset, $ctx) {
  const {ncls: api_normalize_class_name, b: api_bind, d: api_dynamic_text, sp: api_static_part, st: api_static_fragment, k: api_key, i: api_iterator, h: api_element, c: api_custom_element, t: api_text, fr: api_fragment, gid: api_scoped_id} = $api;
  const {_m0, _m1, _m2, _m3, _m4, _m5, _m6, _m7, _m8, _m9, _m10, _m11, _m12, _m13} = $ctx;
  return [$cmp.isOpen ? api_fragment(0, [api_element("div", stc0, [api_custom_element("wds-modal", _wdsModal, {
    className: api_normalize_class_name($cmp.modalClass),
    props: {
      "title": $cmp.modalTitle,
      "closedFocusTarget": $cmp.closedFocusTarget,
      "autoFocusOff": $cmp.isZipMode,
      "bodyScroll": true
    },
    key: 2,
    on: {
      "close": _m0 || ($ctx._m0 = api_bind($cmp.handleModalClose))
    }
  }, [api_element("div", {
    slotAssignment: "main-content",
    className: api_normalize_class_name($cmp.mainContentClass),
    key: 3
  }, [$cmp.isZipMode ? api_fragment(4, [api_static_fragment($fragment1, 6, [api_static_part(0, {
    on: {
      "keydown": _m2 || ($ctx._m2 = api_bind($cmp.handleZipStatusKeydown))
    }
  }, null), api_static_part(1, null, api_dynamic_text($cmp.zipReadyHeading))]), api_element("ol", stc1, api_iterator($cmp.zipInstallSteps, function (step) {
    return api_static_fragment($fragment2, api_key(9, step.id), [api_static_part(1, null, api_dynamic_text(step.text))]);
  })), api_element("p", stc2, [api_custom_element("wds-link", _wdsLink, {
    props: {
      "name": "more-about-claude-skills",
      "href": $cmp.skillsHelpUrl
    },
    key: 11,
    on: {
      "analytics": _m3 || ($ctx._m3 = api_bind($cmp.handleSkillsHelpAnalytics))
    }
  }, [api_element("a", {
    attrs: {
      "href": $cmp.skillsHelpUrl,
      "rel": "noopener noreferrer",
      "target": "_blank"
    },
    key: 12
  }, [api_custom_element("ax-icon", _axIcon, stc3), api_text(api_dynamic_text($cmp.skillsHelpLabel))])])]), api_element("p", stc4, [api_text(api_dynamic_text($cmp.desktopUploadPrompt)), api_custom_element("wds-analytics-instrument", _wdsAnalyticsInstrument, {
    classMap: stc5,
    props: stc6,
    key: 15,
    on: {
      "analytics": _m4 || ($ctx._m4 = api_bind($cmp.handleDesktopUploadAnalytics))
    }
  }, [api_static_fragment($fragment3, 17, [api_static_part(0, {
    attrs: {
      "href": $cmp.desktopUploadUrl
    }
  }, null), api_static_part(1, null, api_dynamic_text($cmp.desktopUploadLabel))])])])], 0) : $cmp.isDesktopMode ? api_fragment(4, [api_element("div", stc7, [$cmp.desktopRetryVisible ? api_fragment(19, [api_static_fragment($fragment4, 21, [api_static_part(1, null, api_dynamic_text($cmp.desktopRetryHeading))])], 0) : api_fragment(19, [api_custom_element("ax-icon", _axIcon, stc8), api_static_fragment($fragment5, 24, [api_static_part(1, null, api_dynamic_text($cmp.desktopOpeningLabel))])], 0)]), api_static_fragment($fragment6, 26, [api_static_part(1, null, api_dynamic_text($cmp.desktopBody))]), api_static_fragment($fragment7, 28, [api_static_part(1, null, api_dynamic_text($cmp.desktopFallback))])], 0) : $cmp.isCliMode ? api_fragment(4, [api_static_fragment($fragment8, 30, [api_static_part(1, null, api_dynamic_text($cmp.subtitle))]), api_static_fragment($fragment9, 32, [api_static_part(0, {
    attrs: {
      "aria-label": $cmp.subtitle
    }
  }, null), api_static_part(2, {
    className: api_normalize_class_name($cmp.commandClasses),
    attrs: {
      "id": api_scoped_id("cli-script-command")
    }
  }, null), api_static_part(3, null, api_dynamic_text($cmp.installCommand))]), api_element("div", stc9, [api_custom_element("wds-button", _wdsButton, {
    classMap: stc10,
    props: {
      "variant": "text",
      "size": "xsmall",
      "type": "button",
      "label": $cmp.showFullCommandLabel,
      "name": "toggle-full-cli-script",
      "ariaExpanded": $cmp.commandAriaExpanded,
      "ariaControls": api_scoped_id("cli-script-command")
    },
    key: 34,
    on: {
      "click": _m5 || ($ctx._m5 = api_bind($cmp.handleToggleCommand)),
      "analytics": _m6 || ($ctx._m6 = api_bind($cmp.handleToggleCommandAnalytics))
    }
  })]), $cmp.showNpxNote ? api_fragment(35, [api_element("p", stc11, [api_custom_element("i18n-link", _i18nLink, {
    props: {
      "message": $cmp.npxNoteMessage,
      "target": "_blank"
    },
    key: 37
  })])], 0) : null], 0) : api_fragment(4, [api_static_fragment($fragment10, 39, [api_static_part(1, null, api_dynamic_text($cmp.subtitle))]), api_static_fragment($fragment11, 41, [api_static_part(0, {
    attrs: {
      "aria-label": $cmp.subtitle
    }
  }, null), api_static_part(3, null, api_dynamic_text($cmp.promptText))])], 0)]), api_element("div", stc12, [$cmp.isZipMode ? api_fragment(43, [api_custom_element("wds-button", _wdsButton, {
    classMap: stc13,
    props: {
      "variant": "primary",
      "label": $cmp.doneLabel,
      "name": "done-install-in-claude"
    },
    key: 44,
    on: {
      "click": _m7 || ($ctx._m7 = api_bind($cmp.handleDone)),
      "analytics": _m8 || ($ctx._m8 = api_bind($cmp.handleDoneAnalytics))
    }
  })], 0) : $cmp.isDesktopMode ? api_fragment(43, [$cmp.desktopRetryVisible ? api_fragment(45, [api_custom_element("wds-button", _wdsButton, {
    classMap: stc14,
    props: {
      "variant": "secondary",
      "label": $cmp.tryAgainLabel,
      "icon": "refresh",
      "name": "try-again-claude-desktop"
    },
    key: 46,
    on: {
      "click": _m9 || ($ctx._m9 = api_bind($cmp.handleTryAgain)),
      "analytics": _m10 || ($ctx._m10 = api_bind($cmp.handleTryAgainAnalytics))
    }
  })], 0) : null, api_custom_element("wds-button", _wdsButton, {
    classMap: stc15,
    props: {
      "variant": "primary",
      "label": $cmp.downloadZipLabel,
      "icon": "download",
      "name": "download-zip",
      "href": $cmp.zipUrl
    },
    key: 47,
    on: {
      "analytics": _m11 || ($ctx._m11 = api_bind($cmp.handleDownloadZipAnalytics))
    }
  })], 0) : api_fragment(43, [api_custom_element("wds-button", _wdsButton, {
    classMap: stc16,
    props: {
      "variant": "primary",
      "label": $cmp.copyButtonLabel,
      "icon": "copy",
      "name": $cmp.copyButtonName
    },
    key: 48,
    on: {
      "click": _m12 || ($ctx._m12 = api_bind($cmp.handleCopy)),
      "analytics": _m13 || ($ctx._m13 = api_bind($cmp.handleAnalytics))
    }
  })], 0)])])])], 0) : null];
  /*LWC compiler v7.1.3*/
}
export default registerTemplate(tmpl);
tmpl.stylesheets = [];
tmpl.stylesheetToken = "lwc-6crad47sfk7";
tmpl.legacyStylesheetToken = "undefined-_guidedInstallModal";
if (_implicitStylesheets) {
  tmpl.stylesheets.push.apply(tmpl.stylesheets, _implicitStylesheets);
}
if (_implicitScopedStylesheets) {
  tmpl.stylesheets.push.apply(tmpl.stylesheets, _implicitScopedStylesheets);
}
freezeTemplate(tmpl);
